import { CustomCategoryHierarchy } from '@catalog/const';
import { StateUtils } from '@spartacus/core';
import { CATEGORY_DETAILS } from '../catalog-state';

export const CATEGORY_DETAILS_LOAD = '[CustomCatalog] Category Details Load';
export const CATEGORY_DETAILS_LOAD_SUCCESS = '[CustomCatalog] Category Details Load Success';
export const CATEGORY_DETAILS_LOAD_FAIL = '[CustomCatalog] Category Details Load Fail';
export const CATEGORY_DETAILS_RESET = '[CustomCatalog] Category Details Reset';

export class LoadCategoryDetails extends StateUtils.LoaderLoadAction {
  readonly type = CATEGORY_DETAILS_LOAD;

  constructor(public payload: string) {
    super(CATEGORY_DETAILS);
  }
}

export class LoadCategoryDetailsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CATEGORY_DETAILS_LOAD_SUCCESS;

  constructor(public payload: CustomCategoryHierarchy) {
    super(CATEGORY_DETAILS);
  }
}

export class LoadCategoryDetailsFail extends StateUtils.LoaderFailAction {
  readonly type = CATEGORY_DETAILS_LOAD_FAIL;

  constructor(payload: any) {
    super(CATEGORY_DETAILS, payload);
  }
}

export class ResetCategoryDetails extends StateUtils.LoaderResetAction {
  readonly type = CATEGORY_DETAILS_RESET;

  constructor() {
    super(CATEGORY_DETAILS);
  }
}

export type CategoryDetailsActions =
  | LoadCategoryDetails
  | LoadCategoryDetailsFail
  | LoadCategoryDetailsSuccess
  | ResetCategoryDetails;
